import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { FilterTypes, Filter } from 'app/components/filters/types';
import { FilterCheckbox } from 'app/components/filters/filters-panel/filter-types/filter-checkbox/filter-checkbox';
import { createConditionValue } from './create-condition-value';
import { createFavouriteCondition } from 'app/components/filters/filters-panel/conditions/create-conditions';
import { EditingValues } from 'app/components/filters/filters-panel/types';
import { getConditionForOperator } from '../get-condition';

export const checkboxConfiguration = {
  [FilterTypes.CheckBox]: filterConfiguration(FilterCheckbox)
};

export const checkboxConditionMapper = (editingValues: EditingValues) => {
  return {
    [FilterTypes.CheckBox]: (filter: Filter) => {
      let condValIndex = 1;
      const editingValue = editingValues && editingValues[filter.id];
      const value = editingValue && editingValue.value;
      const conditionValue = createConditionValue(condValIndex++, filter, value);
      const originalCondition = getConditionForOperator(filter.conditions, filter.advancedField.valueOperator);

      return conditionValue ? [createFavouriteCondition(filter, conditionValue, originalCondition)] : [];
    }
  };
};
